module.exports = __webpack_public_path__ + "static/img/want-3.a027de4c.png";